import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderService } from '../../service/order.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from '../../shared/AppSettings';

@Component({
  selector: 'app-details-of-order-for-customer',
  templateUrl: './details-of-order-for-customer.component.html',
  styleUrls: ['./details-of-order-for-customer.component.css']
})
export class DetailsOfOrderForCustomerComponent implements OnInit {

  @Input() OrderId?: number;
  @Input() OrderIdLink: string;
  @Output() orderDetailsCreated: EventEmitter<any> = new EventEmitter();

  readonly rootUrl = AppSettings.webApiURL;
  
  orderDetails: any;

  msgs: Message[] = [];


  constructor(private orderService: OrderService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.getOrderDetails();

    
  }

  getOrderDetails()
  {
    // let orderId = this.route.snapshot.paramMap.get('order');
    let orderFilterByOrderIdEncoded = {
      OrderIdLink: this.OrderIdLink,    
      OrderId: this.OrderId    
    };
    this.orderService.getCustomerOrderDetails(orderFilterByOrderIdEncoded).subscribe((result: any) => {
      this.orderDetails = result;
      this.orderDetailsCreated.emit(this.orderDetails);
    },
      (err: HttpErrorResponse) => {
        let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בקבלת נתונים ';
        this.showMessage('error', '', errMessage);
      });
  }



  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/order/deatils-of-order-for-customer/details-of-order-for-customer.component.ts